import { useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Table } from '../../../components/Table';
import { ControlledCheckbox } from '../../../components/Checkbox';
import { PAGE_TITLES } from '../../../constants';

const PermissionsTable = ({ isLoading }) => {
  const { control } = useFormContext();
  const { fields } = useFieldArray({ control, name: 'sections' });

  const data = useMemo(() => fields.map((field, index) => ({ ...field, index })), [fields]);

  const columns = useMemo(
    () => [
      {
        key: 'section',
        title: 'Страницы',
        render: (value) => <div>{PAGE_TITLES[value] ?? value}</div>,
      },
      {
        key: 'index',
        classHeader: 'w-[120px]',
        title: <div className="text-center">Просмотр</div>,
        render: (value) => (
          <div className="flex items-center justify-center">
            <ControlledCheckbox control={control} name={`sections.${value}.read`} />
          </div>
        ),
      },
      {
        key: 'index',
        classHeader: 'w-[170px]',
        title: <div className="text-center">Редактирование</div>,
        render: (value) => (
          <div className="flex items-center justify-center">
            <ControlledCheckbox control={control} name={`sections.${value}.write`} />
          </div>
        ),
      },
    ],
    [control]
  );

  return <Table columns={columns} data={data} loading={isLoading} rowKey="id" classContainer="mt-6" />;
};

export default PermissionsTable;
